import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowClose } from '@fortawesome/free-solid-svg-icons';
import './Details.css';

const Details = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMode = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="details-container">
      {isOpen ? (
        <div className="details-box" style={{ position: 'relative' }}>
          
          <FontAwesomeIcon 
          title="Fechar detalhes"
            icon={faWindowClose}
            onClick={toggleMode}
            style={{
              position: 'absolute',
              top: '12px',
              right: '12px',
              fontSize: '24px',
              color: '#007bff',
              zIndex: 1001,
              cursor: 'pointer'
            }}
          />

          {/* 👇 Aqui entra o conteúdo externo */}
          <div>
            {children}
          </div>

        </div>
      ) : (
        <button 
          className="details-button"
          onClick={toggleMode}
        >
          ⓘ
        </button>
      )}
    </div>
  );
};

export default Details;